import { useTranslation } from 'react-i18next';
import { GroupChannel } from '@sendbird/chat/groupChannel';
import { sendbirdSelectors, useSendbirdStateContext } from '@sendbird/uikit-react';
import { useAtom, useSetAtom } from 'jotai';
import { channelListQueryParamsAtom, currentChannelAtom } from '../state';
import { commonSnackbarPropsAtom } from '../../common/state/state';
import { Chat_Message_Custom_Type } from '../../../../../packages/utils/packages/chat';

export interface UseLeaveChannelResult {
  leaveChannel: () => Promise<void>;
}

export interface UseLeaveChannelProps {
  currentChannel: GroupChannel;
}

export default function useLeaveChannel(): UseLeaveChannelResult {
  const { t } = useTranslation(['chat', 'common']);
  const globalStore = useSendbirdStateContext();
  const sdkInstance = sendbirdSelectors.getSdk(globalStore);
  const [channelListQueryParams, setChannelListQueryParams] = useAtom(channelListQueryParamsAtom);
  const [currentChannel, setCurrentChannel] = useAtom(currentChannelAtom);
  const setCommonSnackbarProps = useSetAtom(commonSnackbarPropsAtom);

  const leaveChannel = async (): Promise<void> => {
    await new Promise((resolve) => {
      const request = currentChannel!.sendUserMessage({
        message: t('chat:someone_has_left_the_conversation', { name: sdkInstance?.currentUser?.nickname }),
        customType: Chat_Message_Custom_Type.LEFT,
      });

      request.onSucceeded(resolve);
    });
    await currentChannel!.leave(true);
    setCurrentChannel(undefined);

    // force a channel list reset
    setChannelListQueryParams({
      ...channelListQueryParams,
    });

    setCommonSnackbarProps({
      label: t('chat:leave_conversation_success'),
      snackbarProps: {
        open: true,
      },
    })
  };

  return {
    leaveChannel,
  };
}
